import React from 'react'
import classNames from 'classnames'
import { Card, Container } from '@scentregroup/ui'
import Article from '../article'
import { CustomThemeContext, ThemeOption } from '../../context'
import containerStyle from '../container.scss'
import PlanVisitUtilityBox from '../plan-visit-utility-box'
import style from '../feature/index.scss'
import { Centre } from '../../../types/contentful-v1'

export interface OpeningHoursModulesProps {
  centre: Centre
  children: JSX.Element
}

const OpeningHoursModules = ({
  centre,
  children,
}: OpeningHoursModulesProps): React.ReactElement => (
  <CustomThemeContext.Consumer>
    {(themeOption: ThemeOption) => (
      <div
        className={classNames(style.Feature, style.placeholder, {
          [style.Grey]: themeOption.luxury,
        })}
      >
        <Container
          type="large"
          className={classNames(containerStyle.container, style.Container)}
        >
          <Card className={style.Card}>
            <Article
              heading="Opening hours"
              headingType="large"
              dataTestId="opening-hours-title"
            >
              {children}
            </Article>
          </Card>
          <div className={style.Sidebar}>
            <PlanVisitUtilityBox
              heading="Concierge"
              name={`Westfield ${centre.title}`}
              address={centre.physicalAddress}
              address2={`${centre.suburb} ${centre.state} ${centre.postcode}`}
              phoneNumber={centre.telephoneNumber}
              email={centre.emailAddress}
              conciergeService={centre.conciergeService}
              centreSlug={centre.slug}
            />
          </div>
        </Container>
      </div>
    )}
  </CustomThemeContext.Consumer>
)

export default OpeningHoursModules
